/* ===========================================================================
   Média de la fiche merch : défilement d'images, et vue 3D à la demande.
   ---------------------------------------------------------------------------
   Le glissement lui-même n'est PAS ici : il est natif, porté par le
   scroll-snap de mm-main-product-merch.css. Sans ce fichier, on fait glisser
   au doigt ou à la molette et tout fonctionne, avec les points qui restent
   des boutons inertes. Ce script n'ajoute que le confort : les flèches, la
   synchronisation des points, et le montage du lecteur de gaussiennes.

   C'est aussi pour ça que les flèches sont créées ICI et pas en Liquid : un
   bouton rendu côté serveur alors que le JS n'a pas pris la main serait un
   bouton mort.
   =========================================================================== */
(function () {
  'use strict';

  /* ---------- Défilement d'images ---------- */

  function monteSlider(media) {
    var piste = media.querySelector('[data-mm-slides]');
    if (!piste) return;
    var slides = Array.prototype.slice.call(piste.children);
    if (slides.length < 2) return;

    var points = Array.prototype.slice.call(media.querySelectorAll('[data-mm-dot]'));
    var courant = 0;

    function va(i) {
      var cible = slides[Math.max(0, Math.min(slides.length - 1, i))];
      if (cible) piste.scrollTo({ left: cible.offsetLeft, behavior: 'smooth' });
    }

    /* Les flèches. Créées en JS, donc absentes si ce fichier ne tourne pas. */
    function fleche(sens, libelle) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mm-merch__fleche mm-merch__fleche--' + sens;
      b.setAttribute('aria-label', libelle);
      b.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.2"/></svg>';
      b.addEventListener('click', function () { va(courant + (sens === 'suiv' ? 1 : -1)); });
      media.appendChild(b);
      return b;
    }
    var prec = fleche('prec', 'Visuel précédent');
    var suiv = fleche('suiv', 'Visuel suivant');

    points.forEach(function (p, i) {
      p.addEventListener('click', function () { va(i); });
    });

    function peint() {
      points.forEach(function (p, i) {
        if (i === courant) p.setAttribute('aria-current', 'true');
        else p.removeAttribute('aria-current');
      });
      prec.disabled = courant === 0;
      suiv.disabled = courant === slides.length - 1;
    }

    /* On observe les diapos plutôt que d'écouter le scroll : l'observateur ne
       se réveille qu'au franchissement, là où un écouteur de scroll tourne à
       chaque frame pendant tout le glissement. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = slides.indexOf(e.target);
          if (i !== -1 && i !== courant) { courant = i; peint(); }
        });
      }, { root: piste, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    peint();
    monteDrag(piste);
  }


  /* ---------- Tirage a la souris ----------
     Le scroll-snap natif ne se tire pas a la souris : au bureau, on ne peut
     que cliquer les fleches. Ce bloc reprend TEL QUEL le geste deja regle sur
     le rail du menu mobile (assets/mm-header.js, bindRailDrag), y compris ses
     corrections : capture posee seulement quand le geste devient un vrai
     tirage, velocite rapportee au temps, destination projetee puis posee sur
     la diapo la plus proche, et UN SEUL trajet decelere jusque-la. Rendre la
     main au snap en cours de route faisait sursauter le rail. */
  function monteDrag(piste) {
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
    var tire = false, aTire = false;
    var xDepart = 0, scrollDepart = 0, xDernier = 0, tDernier = 0;
    var vitesse = 0, elan = null;

    piste.style.cursor = 'grab';

    /* Un tirage ne doit jamais devenir un glisser-deposer : les images sont
       draggables par defaut et le navigateur partait avec l'image fantome. */
    piste.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function fige() {
      piste.style.scrollSnapType = 'none';
      piste.style.scrollBehavior = 'auto';
    }
    function degele() {
      piste.style.scrollSnapType = '';
      piste.style.scrollBehavior = '';
    }

    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (elan !== null) { cancelAnimationFrame(elan); elan = null; }
      tire = true; aTire = false;
      xDepart = xDernier = e.clientX;
      tDernier = e.timeStamp;
      scrollDepart = piste.scrollLeft;
      vitesse = 0;
      fige();
      piste.style.cursor = 'grabbing';
    });

    piste.addEventListener('pointermove', function (e) {
      if (!tire) return;
      var dx = e.clientX - xDepart;
      if (!aTire && dx > -4 && dx < 4) return;
      if (!aTire) {
        try { piste.setPointerCapture(e.pointerId); } catch (err) {}
      }
      aTire = true;
      var dt = e.timeStamp - tDernier;
      if (dt > 0) {
        var instant = (xDernier - e.clientX) / dt * 16.7;
        vitesse = vitesse * 0.2 + instant * 0.8;
      }
      xDernier = e.clientX;
      tDernier = e.timeStamp;
      piste.scrollLeft = scrollDepart - dx;
    });

    function relache() {
      if (!tire) return;
      tire = false;
      piste.style.cursor = 'grab';
      if (reduit.matches) { degele(); return; }

      var max = piste.scrollWidth - piste.clientWidth;
      if (vitesse > 60) vitesse = 60; else if (vitesse < -60) vitesse = -60;
      var projete = piste.scrollLeft + vitesse * 11.5;
      if (projete < 0) projete = 0; else if (projete > max) projete = max;

      var gauche = piste.getBoundingClientRect().left;
      var cible = projete, meilleur = Infinity;
      Array.prototype.forEach.call(piste.children, function (slide) {
        var pos = slide.getBoundingClientRect().left - gauche + piste.scrollLeft;
        if (pos > max) pos = max;
        var d = pos - projete; if (d < 0) d = -d;
        if (d < meilleur) { meilleur = d; cible = pos; }
      });

      var depuis = piste.scrollLeft, course = cible - depuis;
      if (course > -1 && course < 1) { degele(); return; }
      var duree = 320 + Math.min(vitesse < 0 ? -vitesse : vitesse, 60) * 3;
      var t0 = null;
      (function pose(now) {
        elan = null;
        if (t0 === null) t0 = now || performance.now();
        var t = ((now || performance.now()) - t0) / duree;
        if (t > 1) t = 1;
        var adouci = 1 - (1 - t) * (1 - t) * (1 - t);
        piste.scrollLeft = depuis + course * adouci;
        if (t < 1) elan = requestAnimationFrame(pose);
        else degele();
      })();
    }
    piste.addEventListener('pointerup', relache);
    piste.addEventListener('pointercancel', relache);

    /* Le clic qui conclut un tirage n'est pas un clic : en capture, avant
       que quoi que ce soit d'autre ne le recoive. */
    piste.addEventListener('click', function (e) {
      if (!aTire) return;
      aTire = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  /* ---------- Vue en gaussiennes ---------- */

  function monteSplat(media) {
    var bouton = media.querySelector('[data-mm-splat-toggle]');
    var hote = media.querySelector('[data-mm-splat]');
    if (!bouton || !hote) return;

    var etat = 'images';   // images | chargement | 3d
    var monte = false;
    var chargementSilencieux = false;
    var jauge = bouton.querySelector('[data-mm-splat-jauge]');
    var boite = bouton.querySelector('[data-mm-vue3d-label]');
    var motActuel = bouton.querySelector('[data-mm-vue3d-mot="actuel"]');
    var motSuivant = bouton.querySelector('[data-mm-vue3d-mot="suivant"]');
    var libelleInitial = motActuel ? motActuel.textContent.trim() : 'Vue 3D';

    /* Le libelle ne se remplace pas d'un coup : l'ancien monte et sort, le
       nouveau arrive par le bas. Pendant le telechargement, en revanche, le
       pourcentage change trois fois par seconde : l'animer donnerait une
       bouillie, on ecrit alors directement. */
    var enSwap = false, minuteur = null, vise = null;

    /* UN SEUL SWAP A LA FOIS, ET IL SE TERMINE TOUJOURS.
       La premiere version enchainait les transitions et gardait un filet par
       transitionend : quand une demande plus recente arrivait pendant une
       animation (le pourcentage qui defile juste avant la bascule d'etat), la
       classe restait posee, le mot courant restait hors champ et on lisait la
       couche du dessous. Resultat visible : « 0 % » affiche alors que l'etat
       disait « Photos ».

       Ici, toute nouvelle demande TERMINE NET celle en cours avant de partir,
       et la fin est pilotee par une seule minuterie calee sur la duree du kit.
       Aucun etat intermediaire ne peut survivre. */
    /* AUCUNE DUREE RECOPIEE ICI. La minuterie coupait a 420 ms pour un trajet
       de 300 ms : le mot restait fige 120 ms avant la remise a zero. Et le mot
       et la boite n'ont plus la meme duree, la boite se posant apres lui. On
       releve donc les deux dans le style calcule et on prend la plus longue :
       relacher la largeur avant la fin de sa transition la ferait sauter de sa
       position courante a sa valeur finale, soit exactement l'a-coup qu'on
       cherche a supprimer. Regler le CSS suffit, le JS suit. */
    function enMs(v) {
      return String(v).split(',').reduce(function (max, part) {
        part = part.trim();
        var n = parseFloat(part) || 0;
        return Math.max(max, /ms$/.test(part) ? n : n * 1000);
      }, 0);
    }
    function dureeSwap() {
      return Math.max(
        enMs(getComputedStyle(motActuel).transitionDuration),
        enMs(getComputedStyle(boite).transitionDuration)
      );
    }

    function termine() {
      if (minuteur) { clearTimeout(minuteur); minuteur = null; }
      if (vise !== null) { motActuel.textContent = vise; vise = null; }
      motSuivant.textContent = '';
      boite.style.width = '';
      /* LA REMISE A ZERO NE DOIT PAS SE VOIR. Retirer `is-swap` renvoie les
         deux mots a leur position de repos, et cette position se rejoignait
         EN TRANSITION : le mot arrive redescendait du haut juste apres etre
         monte. C'est le clignotement. Les trajets sont coupes le temps d'une
         frame, la lecture forcee valide la position, puis ils reprennent. */
      boite.classList.add('sans-transition');
      boite.classList.remove('is-swap');
      void boite.offsetWidth;
      boite.classList.remove('sans-transition');
      enSwap = false;
    }

    function dit(texte, anime) {
      if (!motActuel) return;
      if (enSwap) termine();
      if (motActuel.textContent.trim() === texte) return;
      if (!anime) { motActuel.textContent = texte; return; }
      enSwap = true;
      vise = texte;
      /* LARGEUR FIGEE PENDANT L'ECHANGE. « Vue 3D » et « Photos » ne font pas
         la meme largeur : sans ca, le bouton se retrecit d'un coup au moment
         ou le texte change, et le mouvement se lit comme un accroc. On garde
         la plus grande des deux le temps du trajet, puis on relache. */
      var avant = boite.getBoundingClientRect().width;
      motSuivant.textContent = texte;
      /* La largeur d'arrivee, c'est celle que la boite aura une fois relachee :
         le mot seul, ou le plancher impose pendant le chargement. En visant
         cette valeur, le relachement ne deplace plus rien. */
      var apres = Math.max(
        motSuivant.getBoundingClientRect().width,
        parseFloat(getComputedStyle(boite).minWidth) || 0
      );
      boite.style.width = avant + 'px';
      /* Une lecture forcee : sans elle le navigateur regroupe l'ecriture du
         texte et l'ajout de la classe, part de l'etat d'arrivee, et la
         transition ne se joue pas. */
      void boite.offsetWidth;
      boite.classList.add('is-swap');
      boite.style.width = apres + 'px';
      minuteur = setTimeout(termine, dureeSwap() + 20);
    }

    /* LA BASCULE. Fondu croise ASYMETRIQUE, la regle du theme : ce qui arrive
       s'allume vite, ce qui part s'eteint lentement et un peu apres. L'oeil
       est deja sur l'objet qui apparait ; en vision peripherique, une sortie
       courte se lit comme un saut. Les durees vivent dans le CSS, pas ici. */
    function montre(quoi) {
      var slider = media.querySelector('[data-mm-slider]');
      var dots = media.querySelector('[data-mm-dots]');
      /* Les fleches sont posees par le JS sur le media, donc en dehors du
         slider : elles ne partaient pas avec lui et restaient a flotter sur
         la vue 3D, ou elles ne commandent rien. */
      var fleches = Array.prototype.slice.call(media.querySelectorAll('.mm-merch__fleche'));
      var en3d = quoi === '3d';

      media.classList.toggle('is-3d', en3d);
      bouton.setAttribute('aria-pressed', String(en3d));
      dit(en3d ? 'Photos' : libelleInitial, true);

      /* LE SLIDER DISPARAIT VRAIMENT. Une opacite a zero laisse un element
         qui existe encore : il capte les gestes, il reste dans le document,
         et un lecteur d'ecran le deroule. On le sort donc pour de bon, mais
         APRES le fondu : poser `hidden` tout de suite couperait la
         transition net. Dans l'autre sens on le remet AVANT, sinon il n'y a
         rien a faire apparaitre. */
      [slider, dots].concat(fleches).forEach(function (el) {
        if (!el) return;
        if (en3d) {
          el.setAttribute('inert', '');
          el.classList.add('is-sorti');
          clearTimeout(el.__mmSortie);
          el.__mmSortie = setTimeout(function () {
            if (el.classList.contains('is-sorti')) el.hidden = true;
          }, 540);
        } else {
          clearTimeout(el.__mmSortie);
          el.hidden = false;
          el.removeAttribute('inert');
          /* Une frame pour que le navigateur peigne l'etat de depart, sinon
             il passe directement a l'arrivee et le fondu ne se joue pas. */
          requestAnimationFrame(function () { el.classList.remove('is-sorti'); });
        }
      });
      hote.classList.toggle('is-entre', en3d);
      if (en3d) hote.hidden = false;

      if (window.mmSplatViewer) {
        if (en3d) window.mmSplatViewer.revele(hote);
        else window.mmSplatViewer.cache(hote);
      }
      etat = en3d ? '3d' : 'images';
    }

    /* UN CURSEUR, pas deux boutons. Le pincement reste (trackpad et tactile),
       mais il n'est ni visible ni disponible a la souris : sans commande a
       l'ecran, personne ne devine qu'on peut zoomer. Un curseur dit en plus
       OU on en est dans la plage, ce que deux boutons ne montrent jamais.
       C'est un input range natif : il vient avec le clavier, les fleches, et
       le glisser, sans rien reecrire. Pose par le JS parce qu'il ne sert a
       rien sans lui, et visible seulement en vue 3D. */
    var zoomBoite = null, curseur = null;
    function monteZoom() {
      if (zoomBoite) return;
      var v = hote.__mmSplat;
      if (!v) return;
      zoomBoite = document.createElement('div');
      zoomBoite.className = 'mm-merch__zoom';
      curseur = document.createElement('input');
      curseur.type = 'range';
      curseur.min = String(v.bornes[0]);
      curseur.max = String(v.bornes[1]);
      curseur.step = '0.01';
      curseur.value = String(v.valeur());
      curseur.setAttribute('aria-label', 'Zoom de la vue 3D');
      curseur.addEventListener('input', function () {
        v.zoom(parseFloat(curseur.value));
        peintZoom();
      });
      zoomBoite.appendChild(curseur);
      media.appendChild(zoomBoite);
      peintZoom();
    }
    function peintZoom() {
      var v = hote.__mmSplat;
      if (!v || !curseur) return;
      var b = v.bornes;
      /* La part remplie est peinte en CSS depuis cette variable : un range
         natif ne sait pas colorer sa piste avant le curseur. */
      zoomBoite.style.setProperty('--part', ((v.valeur() - b[0]) / (b[1] - b[0])).toFixed(3));
    }

    function progresse(part) {
      var pct = Math.round(part * 100);
      if (jauge) jauge.style.setProperty('--part', part.toFixed(3));
      dit(pct + ' %', false);
    }

    /* L'URL du viewer, budget de gaussiennes compris. Le nuage est en
       niveaux de detail : le viewer choisit la finesse par morceau, sous un
       plafond global. Un telephone ou une machine a peu de memoire recoit un
       plafond bas — l'image reste pleine, chaque morceau descend d'un cran. */
    function urlLuma() {
      var url = bouton.getAttribute('data-luma-embed');
      if (!url) return null;
      if (url.indexOf('budget=') === -1) {
        var memoire = navigator.deviceMemory || 0;
        var tactile = window.matchMedia('(pointer: coarse)').matches;
        var budget = (memoire && memoire <= 4) || tactile ? 400000
                   : (memoire && memoire <= 8) ? 700000
                   : 0;
        if (budget) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + 'budget=' + budget;
        }
      }
      return url;
    }

    function ouvreLuma(url, silencieux) {
      etat = 'chargement';
      chargementSilencieux = !!silencieux;
      /* En mode silencieux les photos restent la vue active : pas de jauge,
         pas de libelle qui change — le visiteur ne doit rien remarquer tant
         que la 3D n'est pas prete. Un clic sur le bouton pendant ce temps
         rend l'attente visible (voir le gestionnaire de clic). */
      if (!silencieux) {
        bouton.setAttribute('aria-busy', 'true');
        bouton.classList.add('is-chargement');
        dit('3D', true);
      }

      var cadre = document.createElement('iframe');
      cadre.className = 'mm-merch__luma';
      cadre.src = url;
      cadre.title = 'Vue 3D du produit';
      cadre.setAttribute('allow', 'fullscreen; xr-spatial-tracking');
      cadre.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      cadre.addEventListener('load', function () {
        if (monte) return;
        monte = true;

        if (chargementSilencieux) {
          /* BASCULE AUTOMATIQUE. Le « load » de l'iframe signale le document,
             pas les gaussiennes : les niveaux de detail arrivent en flux
             derriere. On laisse trois secondes au premier niveau pour se
             peindre, puis on passe a la 3D en rejouant l'animation d'entree —
             la mise au point — au moment ou elle devient VISIBLE : jouee au
             load, elle se serait consommee derriere les photos. Le bouton
             passe a « Photos », le retour reste a un clic. */
          setTimeout(function () {
            if (etat !== 'chargement') return;   // le visiteur a repris la main
            etat = 'images';
            cadre.classList.remove('is-nee');
            void cadre.offsetWidth;              // l'etat initial est repeint
            montre('3d');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { cadre.classList.add('is-nee'); });
            });
          }, 3000);
        } else {
          /* Le reveal attend une frame : poser la classe dans le meme tour
             que l'insertion sauterait la transition, l'etat initial n'ayant
             jamais ete peint. */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { cadre.classList.add('is-nee'); });
          });
        }

        /* A partir d'ici, COMMUN aux deux chemins — un premier jet sortait
           de la fonction dans la branche silencieuse, et comme le
           prechargement silencieux est devenu le chemin par defaut, le rail
           de zoom et le parallax n'etaient plus jamais cables. */

        /* ZOOM PAR CURSEUR, EN DESKTOP, VIA postMessage.
           La molette du viewer est coupee (?nowheel) pour rendre le
           defilement a la page : le zoom passe par le curseur vertical.
           Le moteur ne lit que le SIGNE de deltaY, un evenement est un cran,
           donc le curseur convertit son deplacement en nombre de crans.

           SURTOUT PAS d'acces direct au document de l'iframe. En production,
           /cdn/shop/ est redirige vers cdn.shopify.com : l'iframe change
           d'origine et contentDocument devient null. Le curseur creait alors
           sa poignee mais chaque geste mourait dans le gestionnaire, un zoom
           mort en ligne alors que tout marchait en local, ou le serveur de
           dev sert le meme fichier depuis la meme origine. Le pont
           postMessage traverse les deux cas a l'identique ; en face,
           mm-ssv.html convertit le message en evenements wheel marques
           (__mmSynthetique), seuls a franchir le filtre nowheel.
           Cache au tactile par CSS : la, le pincement fait le travail. */
        var boiteZoom = document.createElement('div');
        boiteZoom.className = 'mm-merch__zoom mm-merch__zoom--curseur';
        var glisseur = document.createElement('input');
        glisseur.type = 'range';
        glisseur.min = '0'; glisseur.max = '1'; glisseur.step = '0.02';
        glisseur.value = '0.5';
        glisseur.setAttribute('aria-label', 'Zoom de la vue 3D');
        var zoomPrec = 0.5, resteZoom = 0;
        glisseur.addEventListener('input', function () {
          var v = parseFloat(glisseur.value);
          /* ~11 crans couvrent la plage zmin-zmax du viewer. */
          resteZoom += (v - zoomPrec) * 11;
          zoomPrec = v;
          var crans = resteZoom > 0 ? Math.floor(resteZoom) : Math.ceil(resteZoom);
          resteZoom -= crans;
          /* Cible '*' assumee : la commande ne transporte rien de sensible,
             et l'origine reelle du cadre depend d'une redirection CDN qu'on
             ne controle pas. */
          if (crans && cadre.contentWindow) {
            cadre.contentWindow.postMessage({ mmZoomCrans: crans }, '*');
          }
        });
        boiteZoom.appendChild(glisseur);
        media.appendChild(boiteZoom);

        /* PARALLAX AU SURVOL, ET FIN DU REVEAL D'ECHELLE.
           La meme boucle pilote les deux, parce qu'ils ecrivent la meme
           propriete : l'echelle descend de 1.08 vers son assiette de 1.045
           (la marge qui permet au parallax de ne jamais decouvrir les bords),
           et le cadre suit doucement le curseur — une translation de quelques
           pixels et une bascule de moins d'un degre, interpolees, jamais
           mappees en direct. La page parente ne recoit aucun mousemove quand
           le pointeur est au-dessus d'un cadre, et le document de l'iframe
           est inaccessible en production (redirection CDN, autre origine) :
           c'est donc le viewer qui emet la position par postMessage, voir
           mm-ssv.html. */
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          (function () {
            var cibleX = 0, cibleY = 0, parX = 0, parY = 0, echelle = 1.08;
            window.addEventListener('message', function (e) {
              var d = e.data;
              if (!d || d.mmPointeur === undefined) return;
              if (d.mmPointeur === null) { cibleX = 0; cibleY = 0; return; }
              cibleX = Math.max(-1, Math.min(1, d.mmPointeur.x * 2 - 1));
              cibleY = Math.max(-1, Math.min(1, d.mmPointeur.y * 2 - 1));
            });
            (function boucleParallax() {
              parX += (cibleX - parX) * 0.045;
              parY += (cibleY - parY) * 0.045;
              echelle += (1.045 - echelle) * 0.03;
              cadre.style.transform =
                'perspective(1100px)' +
                ' scale(' + echelle.toFixed(4) + ')' +
                ' translate3d(' + (parX * -7).toFixed(2) + 'px, ' + (parY * -5).toFixed(2) + 'px, 0)' +
                ' rotateY(' + (parX * 0.7).toFixed(3) + 'deg)' +
                ' rotateX(' + (parY * -0.5).toFixed(3) + 'deg)';
              requestAnimationFrame(boucleParallax);
            })();
          })();
        }
        /* En silencieux, la bascule appartient au minuteur ci-dessus : les
           photos restent la vue active jusque-la, et il n'y a ni jauge ni
           etat occupe a nettoyer puisqu'on n'en a pas montre. */
        if (!chargementSilencieux) {
          bouton.removeAttribute('aria-busy');
          bouton.classList.remove('is-chargement');
          if (jauge) jauge.style.setProperty('--part', '1');
          montre('3d');
        }
      });
      cadre.addEventListener('error', echoueLuma);
      hote.appendChild(cadre);
      /* Une iframe qui ne charge pas ne declenche pas toujours « error » :
         sans ce garde-fou le bouton resterait bloque sur « chargement ». */
      setTimeout(function () { if (!monte) echoueLuma(); }, 25000);

      function echoueLuma() {
        if (monte) return;
        etat = 'images';
        bouton.removeAttribute('aria-busy');
        bouton.classList.remove('is-chargement');
        dit(libelleInitial, true);
        bouton.disabled = true;
      }
    }

    /* PRECHARGEMENT SILENCIEUX, AU POINTEUR FIN SEULEMENT. Les photos
       s'affichent d'abord, c'est ce que la page promet, pendant que la 3D se
       charge en tache de fond ; prete, elle prend la place avec son animation
       d'entree, et le bouton propose le retour aux photos.

       AU TACTILE, ON NE PRECHARGE PAS ET ON NE BASCULE PAS. La bascule
       automatique ne masque pas le slider, elle le SORT du document : montre()
       pose `hidden` 540 ms apres le fondu. Au telephone, le visiteur qui
       feuillette les photos les voit donc disparaitre au bout de trois
       secondes, et le glissement au doigt n'a plus rien a glisser. Le geste
       n'est bloque nulle part, c'est la piste qui n'est plus la : mesure en
       375 px, la piste tombe a 0 x 0 et le slider est en display:none. C'est
       le symptome remonte depuis un iPhone.

       S'ajoute le poids, celui-la meme que le garde Save-Data ci-dessous
       refuse deja : le faire avaler d'office a un forfait mobile n'a pas plus
       de sens. Le bouton « Vue 3D » reste en place et charge a la demande,
       qui est le bon contrat sur petit ecran.

       Restent les trois gardes d'origine : on attend le « load » de la page
       pour ne rien voler au premier rendu, on passe par l'inactivite du
       navigateur, et on s'abstient devant un Save-Data explicite. */
    (function prechargeLuma() {
      var url = urlLuma();
      if (!url) return;
      if (window.matchMedia('(pointer: coarse)').matches) return;
      if (navigator.connection && navigator.connection.saveData) return;
      var lance = function () {
        var repos = window.requestIdleCallback || function (f) { setTimeout(f, 1200); };
        repos(function () {
          if (etat === 'images' && !monte) { ouvreLuma(url, true); }
        });
      };
      if (document.readyState === 'complete') { lance(); }
      else { window.addEventListener('load', lance, { once: true }); }
    })();

    bouton.addEventListener('click', function () {
      if (etat === 'chargement') {
        /* Le prechargement silencieux est en cours : le clic dit « je la veux
           maintenant ». On montre l'attente, la bascule automatique fera le
           reste. */
        if (chargementSilencieux) {
          chargementSilencieux = false;
          bouton.setAttribute('aria-busy', 'true');
          bouton.classList.add('is-chargement');
          dit('3D', true);
        }
        return;
      }
      if (monte) { montre(etat === '3d' ? 'images' : '3d'); return; }

      /* LECTEUR DE LUMA, EN IFRAME. Quand une capture est configuree, c'est
         leur page qui occupe la zone : leur rendu est au-dessus du notre sur
         une capture de scene, et aucune bibliotheque n'entre dans le theme.
         En contrepartie leur page n'expose aucun parametre de camera — pas de
         bornes de zoom, pas d'arret de la rotation — et le curseur de zoom
         reste donc absent, faute de quoi que ce soit a piloter.
         Leur bibliotheque aurait donne les deux, mais elle est abandonnee
         depuis mars 2024 et son API repond 500 Unauthorized. */
      var lumaEmbed = urlLuma();
      if (lumaEmbed) { ouvreLuma(lumaEmbed, false); return; }

      var source = bouton.getAttribute('data-splat');
      var lecteur = bouton.getAttribute('data-viewer');
      if (!source || !lecteur) return;

      /* Rien n'est charge avant ce clic : ni le lecteur, ni le nuage. Un nuage
         de gaussiennes pese plusieurs megaoctets et la grande majorite des
         visiteurs ne le demandera pas. */
      etat = 'chargement';
      bouton.setAttribute('aria-busy', 'true');
      bouton.classList.add('is-chargement');
      dit('0 %', true);

      var script = document.createElement('script');
      script.src = lecteur;
      script.defer = true;
      script.onload = function () {
        if (!window.mmSplatViewer) { echoue(); return; }
        window.mmSplatViewer.monter(hote, source, {
          biais: parseFloat(bouton.getAttribute('data-biais')) ,
          zoom: parseFloat(bouton.getAttribute('data-zoom')),
          rotation: parseFloat(bouton.getAttribute('data-rotation')),
          cible: (bouton.getAttribute('data-cible') || '').split(',').map(parseFloat),
          etendue: parseFloat(bouton.getAttribute('data-etendue')),
          filtre3d: parseFloat(bouton.getAttribute('data-filtre3d')),
          surProgres: progresse,
          surPret: function () {
            if (monte) return;
            monte = true;
            bouton.removeAttribute('aria-busy');
            bouton.classList.remove('is-chargement');
            if (jauge) jauge.style.setProperty('--part', '1');
            monteZoom();
            montre('3d');
          },
          surEchec: echoue
        });
      };
      script.onerror = echoue;
      document.head.appendChild(script);

      function echoue() {
        etat = 'images';
        bouton.removeAttribute('aria-busy');
        bouton.classList.remove('is-chargement');
        dit(libelleInitial, true);
        /* On ne laisse pas un bouton qui a echoue faire croire qu'il marche :
           il redevient cliquable, une deuxieme tentative est legitime. */
        monte = false;
      }
    });
  }

  function init() {
    var media = document.querySelector('[data-mm-merch-media]');
    if (!media) return;
    monteSlider(media);
    monteSplat(media);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
